<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Staking</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.stakings.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new staking</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Currency</th>
                <th class="px-6 pt-6 pb-4">Days</th>
                <th class="px-6 pt-6 pb-4">Status</th>
                <th class="px-6 pt-6 pb-4">Actions</th>
            </tr>
            <tr v-for="staking in stakings.data" :key="staking.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.stakings.edit', staking.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        <img width="25" :src="staking.currency.file.url" class="mr-3" /> {{ staking.currency.name }} ({{ staking.currency.symbol }})
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link :href="route('admin.stakings.edit', staking.id)" class="px-6 py-4 flex items-center">
                        {{ staking.allowed_days }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge v-if="staking.status == 'active'" class="mr-2" type="green">
                            {{ 'Active' }}
                        </badge>
                        <badge v-if="staking.status == 'sold'" class="mr-2" type="orange">
                            {{ 'Sold Out' }}
                        </badge>
                        <badge v-if="staking.status == 'hidden'" class="mr-2" type="gray">
                            {{ 'Hidden' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <nav-button-link class="mr-2" type="red" :href="route('admin.stakings.edit', staking.id)">
                            <span>Edit</span>
                        </nav-button-link>
                    </span>
                </td>
            </tr>
            <tr v-if="stakings.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No staking found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="stakings.links" />
</app-layout>
